var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8498 9.21018L34.8298 7.2302C36.4702 5.58994 39.1296 5.58994 40.7698 7.2302C42.41 8.87048 42.41 11.5299 40.7698 13.1701L38.7898 15.1501M32.8498 9.21018L19.5312 22.5288C18.5161 23.544 17.7961 24.8156 17.4479 26.2082L16 32L21.7918 30.552C23.1844 30.204 24.456 29.4838 25.4712 28.4688L38.7898 15.1501M32.8498 9.21018L38.7898 15.1501",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9998 27C37.9998 33.575 37.9998 36.8624 36.184 39.0752C35.8516 39.4802 35.4802 39.8516 35.075 40.184C32.8624 42 29.5748 42 22.9998 42H22C14.4575 42 10.6863 42 8.34318 39.6568C6.00006 37.3138 6 33.5424 6 26V25C6 18.425 6 15.1376 7.81588 12.9249C8.14834 12.5198 8.5198 12.1483 8.92488 11.8159C11.1376 10 14.425 10 21 10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.77fe673c91ca79b4236110e75023fe6b.svg";
export { ForwardRef as ReactComponent };